import StaffManagementTableHelper from "./staff-management-table-helper";
import StaffAttendanceTableHelper from "./staff-attendance-table-helper";
import StaffAttendanceSessionHelper from "./staff-attendance-session-helper";
import StaffScanLocationHelper from "./staff-scan-location-helper";
import StaffAuditLogPresentationHelper from "./staff-audit-log-presentation-helper";
import StaffAuditLogTableHelper from "./staff-audit-log-table-helper";
import * as StaffCheckQrHelper from "./staff-check-qr-helper";
import * as StaffEventsApiHelper from "./staff-events-api-helper";
import * as StaffCheckInSetupHelper from "./staff-check-in-setup-helper";


const StaffManagementHelpers = {
    TableMain: StaffManagementTableHelper,
    AttendanceTable: StaffAttendanceTableHelper,
    AttendanceSession: StaffAttendanceSessionHelper,
    ScanLocation: StaffScanLocationHelper,
    AuditLogPresentation: StaffAuditLogPresentationHelper,
    AuditLogTable: StaffAuditLogTableHelper,
    CheckQr: StaffCheckQrHelper,
    CheckInSetup: StaffCheckInSetupHelper,
    EventsApi: StaffEventsApiHelper,
};

export default StaffManagementHelpers;
